//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, onMounted } from '@nuxtjs/composition-api';
import { useRoute } from '@nuxtjs/composition-api';
import { useOrderClose } from '@bee-hole/coms';
import OrderHistoryTab from '~/components/MyAccount/OrderHistoryTab.vue';
import OrderPaymentTab from '~/components/MyAccount/OrderPaymentTab.vue';
import AfterSalesTab from '~/components/MyAccount/AfterSalesTab.vue';
import confirmModal from '~/components/ContentModal/confirm';
import { SfTabs } from '@storefront-ui/vue';

export default {
  name: 'OrderHistory',
  components: {
    OrderHistoryTab,
    OrderPaymentTab,
    AfterSalesTab,
    confirmModal,
    SfTabs
  },
  setup() {
    const openAction = ref(1);
    const confirmModal1 = ref(null);
    const cancelOrderData = ref(null);
    const route = useRoute();
    const { closeOrder, result: cancelRes } = useOrderClose();
    const orderPaymentTab = ref(null);
    const orderHistoryTab = ref(null);
    const afterSalesTab = ref(null);
    const handleApplyOk = () => {
      changeTab(openAction.value);
    };

    const handleCancelSuccess = () => {
      changeTab(openAction.value);
    };

    const changeTab = (tabIndex) => {
      openAction.value = tabIndex;
      console.log('tabIndex', tabIndex);
      if (tabIndex === 1) {
        orderHistoryTab.value.loadOrders();
      } else if (tabIndex === 2) {
        orderPaymentTab.value.loadOrders();
      } else if (tabIndex === 3) {
        afterSalesTab.value.loadOrders();
      }
    };

    const cancelOrder = (order) => {
      cancelOrderData.value = order;
      confirmModal1.value.setModal({
        title: 'Close Order',
        context: 'Are you sure you want to close this order?'
      });
    };

    const okCloseOrder = async () => {
      await closeOrder(cancelOrderData.value.prepay_id);
      console.log('cancelRes', cancelRes.value);
      if (cancelRes.value?.code === 0) {
        orderPaymentTab.value.cancelSuccess();
        // Emit success event or handle accordingly
      }
    };

    onMounted(() => {
      if (route.value?.query?.open) {
        openAction.value = Number(route.value.query.open);
      }
    });

    return {
      openAction,
      confirmModal1,
      cancelOrderData,
      handleApplyOk,
      handleCancelSuccess,
      changeTab,
      cancelOrder,
      okCloseOrder,
      orderPaymentTab,
      orderHistoryTab,
      afterSalesTab
    };
  }
};
